<!-- <h1 *ngIf="member">{{member.nickName}}</h1> -->

<!-- <div *ngIf="editForm.dirty"><span>Your Profile</span> <span >You have made changes, Any unsaved changes will be lost</span></div> -->

<div *ngIf="member" class="main">
  <mat-card class="example-card">
      <mat-card-header>
        <div mat-card-avatar class="example-header-image"></div>
        <mat-card-title>{{member.userName}}</mat-card-title>
        <mat-card-subtitle>{{member.city}}, {{member.country}}</mat-card-subtitle>
      </mat-card-header>
      <img mat-card-image src="{{member.photoUrl || '/assets/ugo.jpg'}}" alt="Photo of a Shiba Inu">

      <mat-card-content>
        <span>Age: </span><span>{{member.age}}</span>
      </mat-card-content>
        
        <mat-card-content>
        <span bold>Member Since: </span><span>{{member.created | date}}</span>
        </mat-card-content>

        
      <mat-card-content>
          <span>Last Active: </span><span>{{member.lastActive | timeago}}</span>
      </mat-card-content>

      <mat-card-actions>
      
        <button [disabled]="! editForm.dirty" form="editform" color="primary" mat-raised-button>Save Changes</button>
      </mat-card-actions>

    </mat-card>

    <mat-card class="example-card2">
      <mat-tab-group animationDuration="0ms" color="accent" backgroundColor="primary">
          <mat-tab label='About {{member.userName}}'>

              <div class="tab-content">
 
                <form id="editform" #editForm="ngForm" class="example-form"
                (ngSubmit)="updateMember()">

                  <mat-form-field class="example-full-width">
                    <mat-label>Description:</mat-label>
                    <textarea class="form-control" name="introduction" [(ngModel)]="member.introduction" matInput placeholder="Looking for..."></textarea>
                  </mat-form-field>

                  <mat-form-field class="example-full-width">
                    <mat-label>Looking for:</mat-label>
                    <textarea class="form-control" name="lookingFor" [(ngModel)]="member.lookingFor" matInput placeholder="Looking for..."></textarea>
                  </mat-form-field>

                  <mat-form-field class="example-full-width">
                    <mat-label>Interests:</mat-label>
                    <textarea class="form-control" name="interests" [(ngModel)]="member.interests" matInput placeholder="Interests..."></textarea>
                  </mat-form-field>

                  <table class="example-full-width" cellspacing="0">
                    <tr>
                      <td>
                        <mat-form-field class="example-full-width">
                          <mat-label>City</mat-label>
                          <input name="city" [(ngModel)]="member.city" matInput>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field class="example-full-width">
                          <mat-label>Country</mat-label>
                          <input name="country" [(ngModel)]="member.country" matInput>
                        </mat-form-field>
                      </td>
                      </tr>
                  </table>
                  
                </form>
              </div>
                 
          </mat-tab>

          <mat-tab label="Edit Photos">

            <div class="tab-content">
              <app-photo-editor [member]="member"></app-photo-editor>
            </div>
             
          </mat-tab>
        </mat-tab-group>
    </mat-card>

</div>
